import { useEffect, useRef, useState } from "react"

import { Button, Flex } from "@/atoms"
import { Trans, useTranslation } from "@/hooks/useTranslation"
import { ExclamationCircleFilled, SafetyCertificateOutlined } from "@/icons"
import { InformationAlert } from "@/molecules/InformationAlert"

import styles from "./HardenAgent.module.scss"

import type { HardeningBannerProps } from "./HardenAgent.types"

// Simulates the analysis step before the suggestions open.
const GENERATE_DELAY_MS = 2000

export const HardeningBanner = (props: HardeningBannerProps) => {
  const { suggestions, onHarden } = props
  const { t } = useTranslation("translation", {
    keyPrefix: "governance.ai.harden"
  })
  const [generating, setGenerating] = useState(false)
  const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined)

  useEffect(() => () => clearTimeout(timer.current), [])

  if (suggestions.length === 0) return null

  const generate = () => {
    setGenerating(true)
    timer.current = setTimeout(() => {
      setGenerating(false)
      onHarden()
    }, GENERATE_DELAY_MS)
  }

  return (
    <InformationAlert
      type="warning"
      className={styles.banner}
      icon={<ExclamationCircleFilled />}
      message={
        <Flex align="center" justify="space-between" gap={16}>
          <span className={styles.bannerText}>
            <Trans>{t("banner")}</Trans>
          </span>
          <Button
            loading={generating}
            icon={<SafetyCertificateOutlined />}
            onClick={generate}
          >
            {t("cta")}
          </Button>
        </Flex>
      }
    />
  )
}
